import React, { Component, lazy, Suspense } from 'react';
import { Layout, Button, Row, Col, Popover, Tooltip } from 'antd';
import { IoHomeOutline, IoAppsOutline, IoCheckmarkDoneOutline } from 'react-icons/io5';
import { MdCallSplit, MdCached, MdOutlineFullscreen, MdOutlineDashboard } from 'react-icons/md';
import FeatherIcon from 'feather-icons-react';
import { NavLink, Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import propTypes, { object } from 'prop-types';
import MenueItems from './menue-items';
import TopMenu from './top-menu';
import { Div, SmallScreenAuthInfo, TopMenuSearch } from './style';
import TopFlowPopover from './flow-list-popover';
import AvatarImage from '../components/cp-account-image';
import AuthInfo from '../components/cp-user-profile/cp-info';
import { changeRtlMode, changeLayoutMode, changeMenuMode } from '../redux/theme-layout/action-creator';
import NotificationsService from '../config/notification-config/notifications-service';
import { getSession } from '../services/storage-service';
import './menu-items.css';
import { hooperLinks } from '../constants';
import logger from '../services/logger';

const AppsListPopover = lazy(() => import('./apps-list-popover'));

const { darkTheme } = require('../config/theme/themeVariables');

const { Header, Footer, Sider, Content } = Layout;
// const { darkMode } = config;
const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        collapsed: false,
        hide: true,
        // searchHide: true,
        activeSearch: false,
        showNavbar: false,
        isFullScreen: false,
        appsPopoverVisible: false,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      // Add event listener to disable right-click
      window.addEventListener('contextmenu', this.disableRightClick);
      this.updateDimensions();
    }

    componentDidUpdate() {
    // const { location } = this.props;
    // const prevLocation = prevProps.location;
    // if (location.pathname !== prevLocation.pathname) {
    //   this.setState({ appsPopoverVisible: false });
    //   if (location.pathname.includes('services/transactions') || location.pathname.includes('services/txn')) {
    //     this.setState({
    //       collapsed: true,
    //     });
    //   } else {
    //     this.setState({
    //       collapsed: false,
    //     });
    //   }
    // }
    }

    componentWillUnmount() {
      // Remove event listener when component unmounts
      window.removeEventListener('contextmenu', this.disableRightClick);
      window.removeEventListener('resize', this.updateDimensions);
    }

    // eslint-disable-next-line class-methods-use-this
    disableRightClick = (e) => {
      e.preventDefault();
    };

    updateDimensions() {
      this.setState({
        // collapsed: window.innerWidth <= 1200 && true,
      });
    }

    render() {
      const { collapsed, hide, activeSearch, showNavbar, appsPopoverVisible } = this.state;
      const { ChangeLayoutMode, rtl, topMenu, changeRtl, changeLayout, changeMenuMode, bizData, match, location } = this.props;

      const userRole = getSession(`${bizData?.id}_biz_Accocunt_user_obj`, true)?.roleType;
      let isPublicForm = false;
      if (location?.pathname?.includes('public/form')) {
        isPublicForm = true;
      }

      // getting the login user biz code.
      const left = !rtl ? 'left' : 'right';
      const darkMode = ChangeLayoutMode;

      const handleFullScreen = () => {
        const { isFullScreen } = this.state;
        const element = document.documentElement; // Get the root HTML element

        if (!isFullScreen) {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
        if (document.exitFullscreen) {
          document.exitFullscreen().catch((err) => {
            logger.error('Exit full screen error:', err);
          });
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        // Toggle the full-screen state
        this.setState((prevState) => ({
          isFullScreen: !prevState.isFullScreen,
        }));
      };

      const toggleCollapsed = () => {
        this.setState({
          collapsed: !collapsed,
        });
      };

      // const onChangeToggleSwitch = (checked) => {
      //   this.setState({
      //     showNavbar: checked,
      //   });
      //   toggleCollapsed();
      // };

      const toggleCollapsedMobile = () => {
        if (window.innerWidth <= 990) {
          this.setState({
            collapsed: !collapsed,
          });
        }
      };

      // const onShowHide = () => {
      //   this.setState({
      //     hide: !hide,
      //     searchHide: true,
      //   });
      // };

      const toggleSearch = () => {
        this.setState({
          activeSearch: !activeSearch,
        });
      };

      // const handleSearchHide = (e) => {
      //   e.preventDefault();
      //   this.setState({
      //     searchHide: !searchHide,
      //     hide: true,
      //   });
      // };

      const footerStyle = {
        padding: '10px 0px 10px',
        color: 'rgba(0, 0, 0, 0.65)',
        fontSize: '14px',
        background: '#e1e1e1',
        width: '95.4%',
        boxShadow: '0 -5px 10px rgba(146,153,184, 0.05)',
      };

      const SideBarStyle = {
        margin: '75px 0 0 0',
        padding: '15px 15px 55px 15px',
        overflowY: 'auto',
        height: '100vh',
        position: 'fixed',
        [left]: 0,
        zIndex: 998,
      };

      const HideSideBarStyle = {
        display: 'none',
      };

      const renderView = ({ style, ...props }) => {
        const customStyle = {
          marginRight: 'auto',
          [rtl ? 'marginLeft' : 'marginRight']: '-17px',
        };
        return <div {...props} style={{ ...style, ...customStyle }} />;
      };

      const renderThumbVertical = ({ style, ...props }) => {
        const { ChangeLayoutMode } = this.props;
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
          [left]: '2px',
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
      };

      const renderTrackVertical = () => {
        const thumbStyle = {
          position: 'absolute',
          width: '6px',
          transition: 'opacity 200ms ease 0s',
          opacity: 0,
          [rtl ? 'left' : 'right']: '2px',
          bottom: '2px',
          top: '2px',
          borderRadius: '3px',
        };
        return <div style={thumbStyle} />;
      };

      const renderThumbHorizontal = ({ style, ...props }) => {
        const { ChangeLayoutMode } = this.props;
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
      };

      const onRtlChange = () => {
        const html = document.querySelector('html');
        html.setAttribute('dir', 'rtl');
        changeRtl(true);
      };

      const onLtrChange = () => {
        const html = document.querySelector('html');
        html.setAttribute('dir', 'ltr');
        changeRtl(false);
      };

      const modeChangeDark = () => {
        changeLayout(true);
      };

      const modeChangeLight = () => {
        changeLayout(false);
      };

      const modeChangeTopNav = () => {
        changeMenuMode(true);
      };

      const modeChangeSideNav = () => {
        changeMenuMode(false);
      };

      const onEventChange = {
        onRtlChange,
        onLtrChange,
        modeChangeDark,
        modeChangeLight,
        modeChangeTopNav,
        modeChangeSideNav,
      };

      return (
        <Div darkMode={darkMode}>
          <Layout className="layout">
            <Header
              className='main_header'
              style={{
                borderBottom: '1px solid rgb(0 0 0 / 6%)',
                position: 'fixed',
                height: '75px',
                width: '100%',
                top: 0,
                background: `${bizData?.styleInfo?.primaryColor || 'linear-gradient(57deg, #1cf7c5, #618bfa)'}`,
                [!rtl ? 'left' : 'right']: 0,
              }}
            >
              <Row>
                <Col lg={!topMenu ? (isPublicForm ? 24 : 8) : (isPublicForm ? 24 : 1)} sm={isPublicForm ? 24 : 4} xs={isPublicForm ? 24 : 10} md={isPublicForm ? 24 : 10} className="align-center-v navbar-brand mt-5">
                  {userRole !== 'NORMAL' && !isPublicForm && (
                    <>
                      {!showNavbar && (
                        <>
                          {!topMenu || window.innerWidth <= 991 ? (
                            <Button type="link" onClick={toggleCollapsed}>
                              <img
                                src={
                                  collapsed
                                    ? require(`../static/img/icon/right.svg`).default
                                    : require(`../static/img/icon/left.svg`).default
                                }
                                alt=""
                              />
                            </Button>
                          ) : null}
                        </>
                      )}
                    </>
                  )}

                  <Link
                    className={topMenu && window.innerWidth > 991 ? 'striking-logo top-menu' : 'mobile_striking-logo'}
                    to={`${!isPublicForm ? `${match?.url}/business/dashboard` : `${location?.pathname}`}`}
                  >
                    {bizData?.logoUrl ? (
                      <AvatarImage image={bizData?.logoUrl} type="IMAGE" classValue="" sizeVal={50} />
                    ) : (
                      <AvatarImage
                        image={bizData?.title?.slice(0, 1).toUpperCase()}
                        classValue=""
                        type="AVATAR"
                        sizeVal={50}
                      />
                    )}
                    <span
                      style={{
                        // padding: '10px',
                        color: `${bizData?.styleInfo?.bTitleColor || '#ffffff'}`,
                        fontSize: `${bizData?.styleInfo?.bTitleSize || '24px'}`,
                        fontWeight: 'bold',
                        position: 'absolute',
                        top: '0px',
                        marginLeft: '10px'
                      }}
                    >
                      {bizData?.title}
                    </span>
                  </Link>
                </Col>

                {!isPublicForm &&
                  <Col lg={!topMenu ? 8 : 15} md={8} sm={0} xs={0}>
                    {topMenu && window.innerWidth > 991 ? <TopMenu /> : ''}
                  </Col>
                }

                {/* <Col lg={6} md={10} sm={0} xs={0}> */}
                {!isPublicForm && topMenu && window.innerWidth > 991 ? (
                  <TopMenuSearch>
                    <div className="top-right-wrap d-flex">
                      <Link
                        className={activeSearch ? 'search-toggle active' : 'search-toggle'}
                        onClick={() => {
                          toggleSearch();
                        }}
                        to="#"
                      >
                        <FeatherIcon icon="search" />
                        <FeatherIcon icon="x" />
                      </Link>
                      <div className={activeSearch ? 'topMenu-search-form show' : 'topMenu-search-form'}>
                        <form action="">
                          <span className="search-icon">
                            <FeatherIcon icon="search" />
                          </span>
                          <input type="text" name="search" />
                        </form>
                      </div>
                      <AuthInfo />
                    </div>
                  </TopMenuSearch>
                ) : (
                    <>
                      {!isPublicForm &&
                        <Col md={8} lg={8} xs={12} align="right">
                          {/* <Switch defaultChecked={showNavbar} onChange={onChangeToggleSwitch} className="top-menu-switch" /> */}
                          <div className='m-t-20 header-right-icons'>
                            <ul>
                              {/* {userRole !== 'NORMAL' && (
                            <li>
                              <div>
                                <Switch
                                  defaultChecked={showNavbar}
                                  onChange={onChangeToggleSwitch}
                                  className="top-menu-switch"
                                />
                              </div>
                            </li>
                            )} */}
                              <li>
                                <Tooltip overlayClassName="header-icons-tooltip" title="Home" placement="bottomLeft">
                                  <div className="cursor-icon">
                                    <Link to={`${match?.url}/business/dashboard`} className="flex_center">
                                      <IoHomeOutline
                                        className="icon_style_25 header_icon_default_color"
                                        style={{ color: `${bizData?.styleInfo?.headerIconsColor || '#ffffff'}` }}
                                      />
                                    </Link>
                                  </div>
                                </Tooltip>
                              </li>
                              <li>
                                <Tooltip overlayClassName="header-icons-tooltip" title="Insights" placement="bottomLeft">
                                  <div className="cursor-icon">
                                    <Link to={`${match?.url}/app/dashboards`} className="flex_center">
                                      <MdOutlineDashboard
                                        className="icon_style header_icon_default_color"
                                        style={{ color: `${bizData?.styleInfo?.headerIconsColor || '#ffffff'}` }}
                                      />
                                    </Link>
                                  </div>
                                </Tooltip>
                              </li>

                              {userRole === 'OWNER' &&
                                <li>
                                  <Tooltip overlayClassName="header-icons-tooltip" title="Flows" placement="bottomLeft">
                                    <div className="cursor-icon">
                                      <Popover
                                        overlayClassName="top-flow-popover"
                                        placement="bottomRight"
                                        content={<TopFlowPopover />}
                                        trigger="click"
                                      >
                                        <MdCallSplit
                                          className="icon_style_25 header_icon_default_color"
                                          style={{ color: `${bizData?.styleInfo?.headerIconsColor}` }}
                                        />
                                      </Popover>
                                    </div>
                                  </Tooltip>
                                </li>
                              }
                              <li>
                                <Tooltip overlayClassName="header-icons-tooltip" title="Apps" placement="bottomLeft">
                                  <div className="cursor-icon">
                                    <Popover
                                      overlayClassName="top-apps-popover"
                                      placement="bottomRight"
                                      content={
                                        <Suspense fallback={<div>Loading...</div>}>
                                          <AppsListPopover />
                                        </Suspense>
                                      }
                                      trigger="click"
                                      open={appsPopoverVisible}
                                      onOpenChange={(visible) => this.setState({ appsPopoverVisible: visible })}
                                    >
                                      <IoAppsOutline
                                        className="icon_style_25 header_icon_default_color"
                                        style={{ color: `${bizData?.styleInfo?.headerIconsColor}` }}
                                      />
                                    </Popover>
                                  </div>
                                </Tooltip>
                              </li>

                              <li>
                                <Tooltip overlayClassName="header-icons-tooltip" title="Tasks" placement="bottomLeft">
                                  <div className="cursor-icon">
                                    <Link to={`${match?.url}/tasks/taskslist`} className="flex_center">
                                      <IoCheckmarkDoneOutline
                                        className="icon_style_25 header_icon_default_color"
                                        style={{ color: `${bizData?.styleInfo?.headerIconsColor}` }}
                                      />
                                    </Link>
                                  </div>
                                </Tooltip>
                              </li>
                              {/* <li>
                            <Tooltip
                              overlayClassName="header-icons-tooltip"
                              title="Business Flow"
                              placement="bottomLeft"
                            >
                              <div className="cursor-icon">
                                <MdOutlineSwapCalls className='icon_style_25' style={{ color: `${bizData?.styleInfo?.headerIconsColor || '#ffffff'}` }} />
                              </div>
                            </Tooltip>
                          </li> */}
                              <li>
                                <Tooltip
                                  overlayClassName="header-icons-tooltip"
                                  title="Page Refresh"
                                  placement="bottomLeft"
                                >
                                  <div className="cursor-icon">
                                    <MdCached
                                      className="icon_style_25 header_icon_default_color"
                                      style={{ color: `${bizData?.styleInfo?.headerIconsColor}` }}
                                      onClick={() => window.location.reload()}
                                    />
                                  </div>
                                </Tooltip>
                              </li>
                              <li>
                                <Tooltip
                                  overlayClassName="header-icons-tooltip"
                                  title="Toggle Fullscreen"
                                  placement="bottomLeft"
                                >
                                  <div className="cursor-icon">
                                    <MdOutlineFullscreen
                                      className="icon_style_25 header_icon_default_color"
                                      style={{ color: `${bizData?.styleInfo?.headerIconsColor}` }}
                                      onClick={() => handleFullScreen()}
                                    />
                                  </div>
                                </Tooltip>
                              </li>
                              <li>
                                <div className="cursor-icon">
                                  <NotificationsService className="header_icon_default_color"
                                    iconColor={`${bizData?.styleInfo?.headerIconsColor}`}
                                  />
                                </div>
                              </li>
                              <li>
                                <div>
                                  <AuthInfo className="header_icon_default_color" iconColor={`${bizData?.styleInfo?.headerIconsColor}`} />
                                </div>
                              </li>
                            </ul>
                          </div>
                        </Col>
                      }
                  </>
                )}

                <Col md={0} sm={18} xs={12}>
                  <div className="mobile-action">
                    {/* <Link className="btn-search" onClick={handleSearchHide} to="#">
                      {searchHide ? <FeatherIcon icon="search" /> : <FeatherIcon icon="x" />}
                    </Link>
                    <Link className="btn-auth" onClick={onShowHide} to="#">
                      <FeatherIcon icon="more-vertical" />
                    </Link> */}
                  </div>
                </Col>
              </Row>
            </Header>
            <div className="header-more">
              <Row>
                <Col md={0} sm={24} xs={24}>
                  <div className="small-screen-headerRight">
                    <SmallScreenAuthInfo hide={hide} darkMode={darkMode}>
                      <AuthInfo rtl={rtl} />
                    </SmallScreenAuthInfo>
                  </div>
                </Col>
              </Row>
            </div>
            <Layout>
              {!topMenu || window.innerWidth <= 991 ? (
                <ThemeProvider theme={darkTheme}>
                  <Sider
                    width={210}
                    style={userRole !== 'NORMAL' && !isPublicForm ? SideBarStyle : HideSideBarStyle}
                    collapsed={!collapsed}
                    theme={!darkMode ? 'light' : 'dark'}
                  >
                    {/* {userRole !== 'NORMAL' && ( */}
                    <>
                      {userRole !== 'NORMAL' && (
                        <Scrollbars
                          className="custom-scrollbar"
                          autoHide
                          autoHideTimeout={500}
                          autoHideDuration={200}
                          renderThumbHorizontal={renderThumbHorizontal}
                          renderThumbVertical={renderThumbVertical}
                          renderView={renderView}
                          renderTrackVertical={renderTrackVertical}
                        >
                          <MenueItems
                            topMenu={topMenu}
                            rtl={rtl}
                            toggleCollapsed={toggleCollapsedMobile}
                            darkMode={darkMode}
                            events={onEventChange}
                          />
                        </Scrollbars>
                      )}
                    </>
                    {/* )} */}
                  </Sider>
                </ThemeProvider>
              ) : null}
              <Layout className={userRole !== 'NORMAL' && !isPublicForm ? 'atbd-main-layout' : 'atbd-main-layout hide-atbd-main-layout'}>
                <Content>
                  <WrappedComponent {...this.props} />
                  {!isPublicForm &&
                    <Footer className="admin-footer" style={footerStyle}>
                      <Row>
                        <Col md={8} xs={24} lg={10}>
                          <img src={require('../static/img/auth/hooper-logo-hor.png')} alt="" />
                        </Col>
                        <Col md={6} xs={24} lg={4}>
                          <span className="admin-footer__copyright">Copyright © 2024 Hooper</span>
                        </Col>
                        <Col md={8} xs={24} lg={10}>
                          <div className="admin-footer__links">
                            <NavLink to="#" onClick={() => window.open(hooperLinks.HOOPER_LINKS.ABOUT)}>
                              About
                            </NavLink>
                            <NavLink to="#" onClick={() => window.open(hooperLinks.HOOPER_LINKS.TERMS)}>
                              Terms
                            </NavLink>
                            <NavLink to="#" onClick={() => window.open(hooperLinks.HOOPER_LINKS.PRIVACY)}>
                              Privacy
                            </NavLink>
                            <NavLink to="#" onClick={() => window.open(hooperLinks.HOOPER_LINKS.DISCLAIMER)}>
                              Disclaimer
                            </NavLink>
                            <NavLink to="#" onClick={() => window.open(hooperLinks.HOOPER_LINKS.COMPLIANCE)}>
                              Compliance
                            </NavLink>
                          </div>
                        </Col>
                      </Row>
                    </Footer>
                  }
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Div>
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      ChangeLayoutMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      bizData: state?.biz?.bizData,
    };
  };

  const mapStateToDispatch = (dispatch) => {
    return {
      changeRtl: (rtl) => dispatch(changeRtlMode(rtl)),
      changeLayout: (show) => dispatch(changeLayoutMode(show)),
      changeMenuMode: (show) => dispatch(changeMenuMode(show)),
    };
  };

  LayoutComponent.propTypes = {
    ChangeLayoutMode: propTypes.bool,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
    changeRtl: propTypes.func,
    changeLayout: propTypes.func,
    changeMenuMode: propTypes.func,
    bizData: object,
    location: object,
    match: object,
  };

  return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
};
export default ThemeLayout;
